import { useEffect } from "react";
import { LANGS } from "@/lib/i18n";

const ORIGIN = process.env.REACT_APP_BACKEND_URL || "";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, hreflang, href) {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Lightweight SEO manager for SPA (title, meta, OG, hreflang, JSON-LD)
export function useSEO({ lang, title, description, path = "", image, jsonLd, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    document.documentElement.setAttribute("lang", lang || "ca");
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (title) {
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", "summary_large_image");
    const url = `${ORIGIN}/${lang}${path}`;
    setMeta("property", "og:url", url);
    setLink("canonical", null, url);
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
    }
    LANGS.forEach((l) => setLink("alternate", l, `${ORIGIN}/${l}${path}`));

    let ld = document.getElementById("osis-jsonld");
    const data = jsonLd || {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "HO-SYS",
      url: `${ORIGIN}/${lang}`,
      description: description || "",
      sameAs: [],
    };
    if (!ld) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.id = "osis-jsonld";
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify(data);
  }, [lang, title, description, path, image, jsonLd, noindex]);
}
